import { GET_USER_MUTUAL_FUND } from '../../actions/types';

const initialState = {
  mutualFunds: []
};

const userMutualFund = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_MUTUAL_FUND:
      return {
        ...state,
        mutualFunds: action.mutualFund
      };
    default: return state;
  }
};

export default userMutualFund;
